import { MenuListItemKey } from 'types/menu-list-items';
import { PartialTranslations } from './default';

export const translationsBundlePl: PartialTranslations = {
    relatedContent: {
        [MenuListItemKey.AppealRights]: 'Prawo do złożenia odwołania',
        [MenuListItemKey.FormAndApplication]: 'Formularze i wnioski',
        [MenuListItemKey.International]: 'Międzynarodowy',
        [MenuListItemKey.Membership]: 'Członkostwo w funduszu ubezpieczeń',
        [MenuListItemKey.ProcessTimes]: 'Czas rozpatrywania spraw',
        [MenuListItemKey.Rates]: 'Stawki',
        [MenuListItemKey.RelatedInformation]: 'Powiązane informacje',
        [MenuListItemKey.ReportChanges]: 'Zgłoś zmiany',
        [MenuListItemKey.RulesAndRegulations]: 'Przepisy',
        [MenuListItemKey.Selfservice]: 'Samoobsługa',
    },
};
